<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <a href="#" @click="$root.showNewBox" style="float: left; padding-right: 10px;"><i class="fa fa-plus-circle" style="font-size: 30px;"></i></a>
      <h1 style="float: left; padding-right: 10px;">{{ $root.title}}</h1>
      <a v-if="hasData" title="Export CSV file" href="#" @click="exportCSV()" style="float: left; padding: 5px 10px;"><i class="fa fa-download" style="font-size: 20px;"></i></a>
      <input v-if="$root.isAdmin && isLocal" type="button" value="Lock All Users" @click="lockAll()" />
      <input v-if="$root.isAdmin && isLocal" type="button" value="UnLock All Users" @click="unlockAll()" />
      <div action="#" method="get" class="sidebar-form" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <VueTable :columns="columns" :info="infoIcons" :rows="filteredItems" @rowClick="rowClick"></VueTable>
      </div>
    </div>
    <AddUser></AddUser>
    <va-modal></va-modal>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import AddUser from '../components/AddUser'
  import Modal from '../components/Modal'
  import VAAlert from '../components/VAAlert.vue'

  import { db } from '../firebase'
  export default {
    name: 'users',
    components: { VueTable, 'va-alert': VAAlert, AddUser, 'va-modal': Modal },
    data () {
      return {
        userKey: '',
        infoIcons: [
          { icon: 'fa fa-lock text-red', label: 'Locked' },
          { icon: 'fa fa-unlock  text-green', label: 'Unlocked' }
        ],
        isLocal: false,
        columns: [
          { fieldName: '.key', label: 'Auth Key', isSortable: true, isHidden: true },
          // { fieldName: 'dealerKey', label: 'dealerKey', isSortable: true, isHidden: true },
          { fieldName: 'FullName', label: 'Name', isSortable: true, isHidden: false },
          // { fieldName: 'FirstName', label: 'First Name', isSortable: true, isHidden: false },
          // { fieldName: 'LastName', label: 'Last Name', isSortable: true, isHidden: false },
          { fieldName: 'Email', label: 'Email', isSortable: true, isHidden: false, length: 40 },
          { fieldName: 'UserType', label: 'Type', isSortable: true, isHidden: false },
          // { fieldName: 'Address', label: 'Address', isSortable: true, isHidden: false },
          // { fieldName: 'Phone', label: 'Phone', isSortable: true, isHidden: false },
          { fieldName: 'DealerName', label: 'Dealer', isSortable: true, isHidden: false },
          { fieldName: 'CompanyName', label: 'Company', isSortable: true, isHidden: false },
          { fieldName: 'Country', label: 'Country', isSortable: true, isHidden: false },
          { fieldName: 'spacedKey', label: 'Auth Key', isSortable: true, isHidden: false, length: 40, className: 'authKey' },
          { fieldName: 'CreateDate', label: 'Create Date', isSortable: true, isHidden: false },
          { fieldName: 'Verified', label: 'Verified', isSortable: true, isHidden: false, isBool: true },
          { fieldName: 'Locked', label: 'Locked', isSortable: true, isHidden: false, isLock: true },
          {
            fieldName: 'VueBottons',
            isSortable: false,
            isHidden: false,
            bottons: [
              { name: 'Edit', label: 'Edit', iconClass: 'fa fa-edit', color: 'green' },
              { name: 'Delete', label: 'Delete', iconClass: 'fa fa-trash-o', color: 'red' }
            ]
          }
        ]
      }
    },
    firebase: function () {
      var vm = this
      let usersPath = 'Users'
      let usersRef = db.ref(usersPath)

      if (vm.$root.isAdmin) {
        return {
          users: usersRef.orderByKey()
        }
      } else {
        return {
          // users: usersRef.orderByChild('DealerUID').equalTo(vm.$root.user['.key'])
          users: usersRef.orderByChild('DealerUID').equalTo(vm.$root.user['DealerUID'])
        }
      }
    },
    created () {
      this.$root.title = 'Users'
      if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        // alert('It is a local server!')
        this.isLocal = true
      }
    },
    mounted () {
      console.log('Users mounted')
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.users.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  row['spacedKey'] = vm.addKeySpacing(row['.key'])
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          for (let i = 0; i < vm.users.length; i++) {
            let row = vm.users[i]
            row['spacedKey'] = vm.addKeySpacing(row['.key'])
          }
          result = vm.users
        }

        for (let i = 0; i < result.length; i++) {
          // getDealerName
          result[i].DealerName = vm.getDealerName(result[i].DealerUID)
          result[i].FullName = result[i].FirstName + ' ' + result[i].LastName
        }
        result = result.sort(vm.$root.compareItems)
        return result
      }
    },
    methods: {
      addKeySpacing (mKey) {
        let sKey = ''
        let maxLength = Math.floor(mKey.length / 4)
        let chars = mKey.split('')
        let counter = 0
        for (let i = 0; i < chars.length; i++) {
          sKey += chars[i]
          counter++
          if (counter === maxLength) {
            sKey += ' '
            counter = 0
          }
        }
        return sKey
      },
      getDealerName (dealerKey) {
        let vm = this
        // console.log(dealerKey)
        if (dealerKey) {
          let foundDealer = vm.$root.dealers.find(function (dealer) {
            return dealer.value === dealerKey
          })
          // console.log(foundDealer)
          if (foundDealer) {
            return foundDealer.title
          } else {
            return ''
          }
        } else {
          return ''
        }
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'LockAll': this.lockAll(); break
          case 'Lock': this.confirmLock(item); break
          case 'Edit': this.edit(item); break
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      lockAll () {
        db.ref('Users').orderByKey().once('value').then(function (snapItems) {
          snapItems.forEach(function (user) {
            user.ref.update({ Locked: true })
          })
        })
      },
      unlockAll () {
        db.ref('Users').orderByKey().once('value').then(function (snapItems) {
          snapItems.forEach(function (user) {
            user.ref.update({ Locked: false })
          })
        })
      },
      edit (item) {
        this.$bus.$emit('userModal-open', item)
      },
      confirmLock (item) {
        const vm = this
        if (!vm.$root.isAdmin) { return }
        let title = 'Lock User'
        let description = 'Are you sure you want to lock'
        if (item.Locked) {
          title = 'Unlock User'
          description = 'Are you sure you want to unlock'
        }
        description = description + ' user [' + item.FullName + ']'
        vm.$bus.$emit('modal-open', {
          title: title,
          description: description,
          type: 'modal-primary',
          confirmText: item.Locked ? 'Unlock' : 'Lock',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            db.ref('Users/' + item['.key'] + '/Locked').set(!item.Locked)
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      confirmDelete (item) {
        const vm = this
        vm.$bus.$emit('modal-open', {
          title: 'Delete User',
          description: 'Are you sure you want to delete user [' + item.FirstName + ' ' + item.LastName + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {},
          confirmAfter: () => {
            console.log(item['.key'])
            db.ref('Users/' + item['.key']).remove()
          },
          cancelBefore: () => {},
          cancelAfter: () => {}
        })
      },
      exportCSV () {
        let vm = this
        let csv = 'Users ' + '\n'
        let headers = []
        //  columns
        for (let i = 0; i < vm.columns.length; i++) {
          headers.push(vm.columns[i].label ? vm.columns[i].label : vm.columns[i].fieldName)
        }
        csv += headers.join(',')
        csv += '\n'
        console.log(csv)
        vm.filteredItems.forEach(function (rowObj) {
          let row = []
          for (let i = 0; i < vm.columns.length; i++) {
            let item = rowObj[vm.columns[i].fieldName]
            if (item) {
              try {
                item = item.toString()
                if (item.indexOf(',') > -1) {
                  item = item.replace(',', '.')
                }
              } catch (e) {
                console.log('Error: ' + item + ' msg: ' + e.message)
              }
              row.push(item)
            } else {
              row.push(' ')
            }
          }
          csv += row.join(',')
          csv += '\n'
        })
        var BOM = '\uFEFF'
        csv = BOM + csv
        console.log(csv)
        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        // hiddenElement.href = 'data:text/csv;charset=utf-8,' + csv
        hiddenElement.target = '_blank'
        hiddenElement.download = 'Users ' + vm.$moment().format('YYYY-MM-DD') + '.csv'
        hiddenElement.click()
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Users.vue?47c47b97